export default __webpack_public_path__ + "static/chrissy-brown-d1efd11df5443dffeb27b8bb540ee4f4.png";